export default [
  {
    title: "Collect Point By Admin",
    customIcon: "CustomSVG",
    children: [
      {
        title: "Collect Point By Admin",
        route: "custom-collect-point-by-admin-approved-receipt-list",
        path: "/custom-collect-point-by-admin/list",
      },
    ],
  },
];
